import { type SxProps, type Theme } from '@andritzot/metris-web-ui';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { type ReactNode } from 'react';

export type StatusBadgeColors =
  | 'blue'
  | 'lightBlue'
  | 'red'
  | 'lightRed'
  | 'lightGreen'
  | 'green'
  | 'lightyellow'
  | 'yellow'
  | 'grey';

interface StatusBadgeProps {
  color: StatusBadgeColors;
  fontSize?: number;
  children: ReactNode;
  breakLine?: boolean;
  sx?: SxProps<Theme>;
}

const colorStyles: Record<StatusBadgeColors, { backgroundColor: string; color: string }> = {
  blue: { backgroundColor: '#b3e5fc', color: '#0075be' },
  lightBlue: { backgroundColor: '#7fbade', color: '#ffffff' },
  red: { backgroundColor: '#c63737', color: '#ffffff' },
  lightRed: { backgroundColor: '#f74d4d', color: '#ffffff' },
  lightGreen: { backgroundColor: '#7ebe78', color: '#ffffff' },
  green: { backgroundColor: '#47a23f', color: '#ffffff' },
  yellow: { backgroundColor: '#fed869', color: '#5f3a2b' },
  lightyellow: { backgroundColor: '#fee6a1', color: '#5f3a2b' },
  grey: { backgroundColor: '#8a8a8a', color: '#ffffff' },
};

const StatusBadge = ({ color, fontSize = 12, children, breakLine = false, sx }: StatusBadgeProps) => {
  const { backgroundColor, color: textColor } = colorStyles[color];
  return (
    <Chip
      label={children}
      sx={{
        backgroundColor,
        color: textColor,
        height: 'auto',
        fontSize,
        fontWeight: 600,
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
        '& .MuiChip-label': {
          px: '0.5rem',
          py: '0.25em',
          whiteSpace: breakLine ? 'normal' : 'nowrap',
          overflow: 'visible',
        },
        '&:hover': { backgroundColor: backgroundColor },
        '&:focus': { backgroundColor: backgroundColor },
        ...sx,
      }}
    />
  );
};

export default StatusBadge;
